<div class="card mb-3">
  <div class="card-body">
    <div class="mb-4">
      <h5 class="card-title">
        @if (task().isProductive) {
          {{ task().customerName }} -
        }
        {{ task().taskName }}
      </h5>
      <h6 class="card-subtitle text-muted">{{ year() }}/{{ month() }}</h6>
    </div>

    @if (metadata()) {
      <div class="d-flex">
        <button
          class="btn btn-sm btn-outline-dark mb-3"
          type="button"
          (click)="downloadTimeSheet()"
          [disabled]="!metadata()"
        >
          <i class="bi bi-download"></i>
          {{ metadata() }}
        </button>
      </div>
    }

    <div class="d-flex gap-2 align-items-start">
      <div class="flex-grow-1">
        <input
          #fileInput
          class="form-control"
          [class.is-invalid]="uploadStatus() === 'error'"
          [class.is-valid]="uploadStatus() === 'success'"
          type="file"
          accept="application/pdf"
          (change)="onFileSelected($event)"
          [disabled]="uploadStatus() === 'uploading'"
        />
      </div>

      <button
        [disabled]="!isFileSelected() || uploadStatus() === 'uploading'"
        [class]="task().accepted ? 'btn btn-warning' : 'btn btn-primary'"
        style="min-width: 110px"
        type="button"
        (click)="upload()"
      >
        @if (uploadStatus() === 'uploading') {
          <span class="spinner-border spinner-border-sm me-1"></span>
          <span
            i18n="
              upload status|Uploading progress label in the upload button for the task
              file@@uploadingLabel"
            >Uploading…</span
          >
        } @else {
          @if (task().accepted) {
            <span i18n="upload button|Text for re-uploading an accepted task@@reUploadText"
              >Re-upload</span
            >
          } @else {
            <span i18n="upload button|Text for uploading a new task@@uploadText">Upload</span>
          }
        }
      </button>
    </div>
  </div>
</div>
